/**
 * Data una stringa ritorna una versione hashata del valore come numero a 32bit.
 * Sembra essere molto più veloce di un hash come md5.
 * Per noi non è necessario un hash sicuro, basta che sia veloce e con poche collisioni.
 * Sembra essere un'implementazione javascript di `hashCode()` di Java.
 * https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript
 */
export function hashValue(value: string): number {
  let hash = 0;
  for (let i = 0, len = value.length; i < len; i++) {
    const chr = value.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
